<template>
  <div class="page-mentor">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/innovation`">创新创业</el-breadcrumb-item>
        <el-breadcrumb-item>投资人</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content content" v-loading="loading">
        <column-header2 :data="metaData"></column-header2>
        <user-list :data="userList"></user-list>
        <el-pagination v-if="total > pageSize" class="g-pagination" background layout="prev, pager, next" :current-page="pageIndex" :page-size="pageSize" :total="total" @current-change="handleIndexChange">
          ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getData } from "api/app";
import SideNav from "_c/SideNav";
import ColumnHeader from "_c/ColumnHeader2";
import UserList from "../components/UserList";

export default {
  data() {
    return {
      loading: false,
      metaData: {
        name: "投资人"
      },
      userList: [],
      total: 0,
      pageSize: 6,
      pageIndex: 1
    };
  },
  created() {
    this.init();
  },
  components: {
    [SideNav.name]: SideNav,
    [ColumnHeader.name]: ColumnHeader,
    [UserList.name]: UserList
  },
  // methods: {
  //   loadData() {
  //     getData({ name: "Investor", top: 9999 }).then(res => {
  //       this.userList = (res || []).map(linkDecorator);
  //     });
  //   },
  //   init() {
  //     this.loadData();
  //   }
  // }
  methods: {
    handleIndexChange(index) {
      this.pageIndex = index;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      const linkDecorator = item => {
        item.link = this.$subsitePrefix + "/innovation/investor-detail/" + item.Id;
        return item;
      };
      var queryParams = {
        name: "Investor",
        index: this.pageIndex,
        size: this.pageSize ?? 6,
        params: []
      };
      queryParams.params = [({ Key: 'WorkFlowState', Value: 2, CompareType: 'GreaterThan' })]
      getData(queryParams)
        .then(res => {
          this.userList = (res.Data || []).map(linkDecorator);
          this.total = res.TotalCount;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        })
    },
    init() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-mentor {
  background: #f6f6f9;
  padding-bottom: 40px;
  ::v-deep .comp-user {
    margin: 10px 48px 0 48px;
  }
  ::v-deep .comp-column-header {
    padding: 10px 0 20px 0;
    margin-left: 48px;
  }
}
</style>
